import Delay from "@/utils/common/delay";

import ProdutoModel from "../models/produto/produtoModel";
import nfetch from "../utils/events/nfetch";

class CapsulaCoresService {
    protected cached: { [franquiaId: number]: ProdutoModel[] } = {};
    protected loadingCache = false;

    public async produtosCoresByFranquiaCached(franquiaId: number, refresh = false) {
        while (this.loadingCache) await Delay(100);

        if (this.cached[franquiaId] && !refresh) {
            return this.cached[franquiaId];
        }

        this.loadingCache = true;
        try {
            const response = await nfetch(`/Capsula/GetProdutosCoresByFranquia?franquiaId=${franquiaId}`, {
                credentials: "same-origin",
            }).resolveWithJSON<ProdutoModel[]>();

            this.cached[franquiaId] = response;

            return response;
        } catch {
        } finally {
            this.loadingCache = false;
        }
    }
}

export default new CapsulaCoresService();
